
export default {
    links: [],
};